import {useEffect, useState} from "react";
import _ from 'lodash'
import {Chip} from "primereact/chip";
import styles from './SelectedFilters.module.css'
export const SelectedFilters = ({checkedFiltersObject, setCheckedFiltersObject}) => {

    const [types, setTypes] = useState([])

    useEffect(() => {
        let keys =  _.keys(checkedFiltersObject);
        setTypes(keys)
    },[checkedFiltersObject])

    const removeHandler = (e, inputObj) => {
        console.log(e.children);
        let id = inputObj.id;
        let type = inputObj.type;
        let deepClone = _.cloneDeep(checkedFiltersObject);

        _.remove(deepClone[type], function(n) {
            return n.Id === id
        });
        setCheckedFiltersObject(deepClone);
    }


    return (
            <div className={styles.selectedFilters}>
                {types.length > 0 ? types.map((type) =>
                    checkedFiltersObject[type].map((filter) =>
                        <Chip style={{marginRight: '5px', marginBottom: '5px'}} onRemove={(event) => removeHandler(event, {id: filter.Id, type: type})} id={filter.id} type={type} key={filter.Name + type} label={filter.Name} removable />
                    )
                ) : null}
            </div>
    )
}